<!-- <div *ngIf="loaderService.loading$ | async" class="layout-preloader-container">
  <div class="layout-preloader-content">
    <mat-progress-spinner
      mode="indeterminate"
      color="orange"
      diameter="64"
      strokeWidth="10">
    </mat-progress-spinner>
  </div>
</div>  -->
<div *ngIf="loaderService.loading$ | async" class="layout-preloader-container">
  <div class="layout-preloader-content">
    <div class="bubbles-spinner">
      <div class="bubble bubble1"></div>
      <div class="bubble bubble2"></div>
      <div class="bubble bubble3"></div>
      <div class="bubble bubble4"></div>
      <div class="bubble bubble5"></div>
      <div class="bubble bubble6"></div>
      <div class="bubble bubble7"></div>
      <div class="bubble bubble8"></div>
    </div>
  </div>
</div>